import { Component, ViewEncapsulation, ElementRef, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnDestroy,
         DoCheck, KeyValueDiffers, KeyValueDiffer, } from '@angular/core';
import { JqGridService } from './grid.service';
import { JqGridInterFaceOptions, JqGridFunctionOptions } from './grid-options';

@Component({
  selector: 'ant-jq-grid',
  template:`<div class="jq-grid-container">
    <table id="#jqGridTableTempId" #jqGridTable class="ng-jq-grid-table"></table>
    <div #jqGridPager></div>
</div>`,
  styles: [`/* 以下是jqGrid默认样式【某些已进行注释或修改：减少文件大小和更适应本bang-UI组件样式】 */
/*Grid*/
.ui-jqgrid {
  position: relative;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.ui-jqgrid .ui-jqgrid-view {
  position: relative;
  left: 0;
  top: 0;
  padding: 0;
  font-size: 11px;
  z-index: 100;
}
.ui-jqgrid .ui-common-table {
  border-width: 0px;
  border-style: none;
  border-spacing: 0px;
  padding: 0;
}
/* caption*/
.ui-jqgrid .ui-jqgrid-titlebar {
  height: 19px;
  padding: .3em .2em .2em .3em;
  position: relative;
  font-size: 12px;
  border-left: 0 none;
  border-right: 0 none;
  border-top: 0 none;
}
.ui-jqgrid .ui-jqgrid-caption {
  text-align: left;
}
.ui-jqgrid .ui-jqgrid-title {
  margin: .1em 0 .2em;
}
.ui-jqgrid .ui-jqgrid-titlebar-close {
  position: absolute;
  top: 50%;
  width: 19px;
  margin: -10px 0 0 0;
  padding: 1px;
  height: 18px;
  cursor: pointer;
}
.ui-jqgrid .ui-jqgrid-titlebar-close span {
  display: block;
  margin: 1px;
}
/* header*/
.ui-jqgrid .ui-jqgrid-hdiv {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-left: 0 none !important;
  border-top: 0 none !important;
  border-right: 0 none !important;
}
.ui-jqgrid .ui-jqgrid-hbox {
  float: left;
  padding-right: 20px;
}
.ui-jqgrid .ui-jqgrid-htable {
  table-layout: fixed;
  margin: 0;
  border-collapse: separate;
}
.ui-jqgrid .ui-jqgrid-htable th {
  height: 27px;
  padding: 0 2px 0 2px;
}
.ui-jqgrid .ui-jqgrid-htable th div {
  overflow: hidden;
  position: relative;
  margin: .1em 0em .1em 0em;
}
.ui-th-column,
.ui-jqgrid .ui-jqgrid-htable th.ui-th-column {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  border-top: 0 none;
  border-bottom: 0 none;
}
.ui-th-column-header,
.ui-jqgrid .ui-jqgrid-htable th.ui-th-column-header {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  border-top: 0 none;
  height: 26px;
}
.ui-th-ltr,
.ui-jqgrid .ui-jqgrid-htable th.ui-th-ltr {
  border-left: 0 none;
}
.ui-th-rtl,
.ui-jqgrid .ui-jqgrid-htable th.ui-th-rtl {
  border-right: 0 none;
}
.ui-first-th-ltr {
  border-right: 1px solid;
}
.ui-first-th-rtl {
  border-left: 1px solid;
}
.ui-jqgrid .ui-th-div-ie {
  white-space: nowrap;
  zoom: 1;
  height: 17px;
}
.ui-jqgrid .ui-jqgrid-resize {
  height: 20px !important;
  position: relative;
  cursor: e-resize;
  display: inline;
  overflow: hidden;
}
.ui-jqgrid .ui-grid-ico-sort {
  overflow: hidden;
  position: absolute;
  display: inline;
  cursor: pointer !important;
}
.ui-jqgrid .ui-icon-asc {
  margin-top: -3px;
  height: 12px;
}
.ui-jqgrid .ui-icon-desc {
  margin-top: 3px;
  margin-left: -1px;
  height: 12px;
}
.ui-jqgrid .ui-i-asc {
  margin-top: 0;
  height: 18px;
}
.ui-jqgrid .ui-i-desc {
  margin-top: 0;
  margin-left: 12px;
  height: 18px;
}
.ui-jqgrid .ui-single-sort-asc {
  margin-top: 0;
  height: 18px;
}
.ui-jqgrid .ui-single-sort-desc {
  margin-top: -1px;
  height: 18px;
}
.ui-jqgrid .ui-jqgrid-sortable {
  cursor: pointer;
  height: 14px;
}
.ui-jqgrid .ui-search-table td.ui-search-clear {
  width: 25px;
}
.ui-jqgrid tr.ui-search-toolbar td > input {
  padding-right: 0px;
  width: 95%;
}
/* body */
.ui-jqgrid .ui-jqgrid-bdiv {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: auto;
  text-align: left;
  z-index: 101;
}
.ui-jqgrid .ui-jqgrid-btable {
  table-layout: fixed;
  margin: 0;
  outline-style: none;
  border-collapse: separate;
}
.ui-jqgrid tr.jqgrow {
  outline-style: none;
}
.ui-jqgrid tr.jqgroup {
  outline-style: none;
}
.ui-jqgrid tr.jqgrow td {
  font-weight: normal;
  overflow: hidden;
  white-space: pre;
  height: 23px;
  padding: 1px 2px 1px 2px;
  border-bottom-width: 1px;
  border-bottom-color: inherit;
  border-bottom-style: solid;
}
.ui-jqgrid tr.jqgfirstrow td {
  padding: 0 2px 0 2px;
  border-right-width: 1px;
  border-right-style: solid;
  height: auto;
}
.ui-jqgrid tr.jqgroup td {
  font-weight: normal;
  overflow: hidden;
  white-space: pre;
  height: 22px;
  padding: 0 2px 0 2px;
  border-bottom-width: 1px;
  border-bottom-color: inherit;
  border-bottom-style: solid;
}
.ui-jqgrid tr.jqfoot td {
  font-weight: bold;
  overflow: hidden;
  white-space: pre;
  height: 22px;
  padding: 0 2px 0 2px;
  border-bottom-width: 1px;
  border-bottom-color: inherit;
  border-bottom-style: solid;
}
.ui-jqgrid tr.ui-row-ltr td {
  text-align: left;
  border-right-width: 1px;
  border-right-color: inherit;
  border-right-style: solid;
}
.ui-jqgrid tr.ui-row-rtl td {
  text-align: right;
  border-left-width: 1px;
  border-left-color: inherit;
  border-left-style: solid;
}
.ui-jqgrid td.jqgrid-rownum {
  padding: 0 2px 0 2px;
  margin: 0;
  border: 0 none;
}
.ui-jqgrid .ui-jqgrid-resize-mark {
  width: 2px;
  left: 0;
  background-color: #777;
  cursor: e-resize;
  cursor: col-resize;
  position: absolute;
  top: 0;
  height: 100px;
  overflow: hidden;
  display: none;
  border: 0 none;
  z-index: 99999;
}
/* footer */
.ui-jqgrid .ui-jqgrid-sdiv {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-left: 0 none !important;
  border-top: 0 none !important;
  border-right: 0 none !important;
}
.ui-jqgrid .ui-jqgrid-ftable {
  table-layout: fixed;
  margin-bottom: 0;
  border-collapse: separate;
}
.ui-jqgrid tr.footrow td {
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  height: 20px;
  padding: 0 2px 0 2px;
  border-top-width: 1px;
  border-top-color: inherit;
  border-top-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: inherit;
  border-bottom-style: solid;
}
.ui-jqgrid tr.footrow-ltr td {
  text-align: left;
  border-right-width: 1px;
  border-right-color: inherit;
  border-right-style: solid;
}
.ui-jqgrid tr.footrow-rtl td {
  text-align: right;
  border-left-width: 1px;
  border-left-color: inherit;
  border-left-style: solid;
}
/* Pager*/
.ui-jqgrid .ui-jqgrid-pager {
  border-left: 0 none !important;
  border-right: 0 none !important;
  border-bottom: 0 none !important;
  border-top: 0 none;
  margin: 0 !important;
  padding: 0 !important;
  position: relative;
  height: auto;
  min-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 11px;
  z-index: 101;
}
.ui-jqgrid .ui-jqgrid-toppager .ui-pager-control,
.ui-jqgrid .ui-jqgrid-pager .ui-pager-control {
  position: relative;
  border-left: 0;
  border-bottom: 0;
  border-top: 0;
  height: 28px;
}
.ui-jqgrid .ui-pg-table {
  position: relative;
  padding: 1px 0;
  width: auto;
  margin: 0;
}
.ui-jqgrid .ui-pg-table td {
  font-weight: normal;
  vertical-align: middle;
  padding: 0px 1px;
}
.ui-jqgrid .ui-pg-button {
  height: auto;
}
.ui-jqgrid .ui-pg-button span {
  display: block;
  margin: 2px;
  float: left;
}
.ui-jqgrid .ui-pg-input,
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-input {
  height: 14px;
  width: auto;
  font-size: .9em;
  margin: 0;
  line-height: inherit;
  border: none;
  padding: 3px 2px;
}
.ui-jqgrid .ui-pg-selbox,
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-selbox {
  font-size: .9em;
  line-height: inherit;
  display: block;
  height: 19px;
  margin: 0;
  padding: 3px 0px;
  border: none;
}
.ui-jqgrid .ui-separator {
  height: 18px;
  border-left: 2px solid #ccc ;
}
.ui-separator-li {
  height: 2px;
  border: none;
  border-top: 2px solid #ccc ;
  margin: 0;
  padding: 0;
  width: 100%;
}
.ui-jqgrid .dropdownmenu {
  padding: 3px 0 3px 0;
  margin-left: 4px;
}
.ui-jqgrid .ui-jqgrid-pager .ui-pg-div,
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-div {
  padding: 1px 0;
  float: left;
  position: relative;
  line-height: 20px;
}
.ui-jqgrid .ui-jqgrid-pager .ui-pg-button,
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-button {
  cursor: pointer;
}
.ui-jqgrid .ui-jqgrid-pager .ui-pg-div span.ui-icon,
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-div span.ui-icon {
  float: left;
  margin: 2px;
  width: 18px;
}
.ui-jqgrid td input,
.ui-jqgrid td select,
.ui-jqgrid td textarea {
  margin: 0;
  padding-top: 5px;
  padding-bottom: 5px;
}
.ui-jqgrid td textarea {
  width: auto;
  height: auto;
}
.ui-jqgrid .ui-jqgrid-toppager {
  border-left: 0 none !important;
  border-right: 0 none !important;
  border-top: 0 none !important;
  margin: 0 !important;
  padding: 0 !important;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
}
.ui-jqgrid .ui-jqgrid-pager .ui-pager-table,
.ui-jqgrid .ui-jqgrid-toppager .ui-pager-table {
  width: 100%;
  table-layout: fixed;
  height: 100%;
}
.ui-jqgrid .ui-jqgrid-pager .ui-paging-info,
.ui-jqgrid .ui-jqgrid-toppager .ui-paging-info {
  font-weight: normal;
  height: auto;
  margin-top: 3px;
  margin-right: 4px;
  display: inline;
}
.ui-jqgrid .ui-jqgrid-pager .ui-paging-pager,
.ui-jqgrid .ui-jqgrid-toppager .ui-paging-pager {
  table-layout: auto;
  height: 100%;
}
.ui-jqgrid .ui-jqgrid-pager .navtable,
.ui-jqgrid .ui-jqgrid-toppager .navtable {
  float: left;
  table-layout: auto;
  height: 100%;
}
/*
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-div {padding:1px 0;float:left;position:relative; line-height: 20px; margin-right:3px;}
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-button { cursor:pointer; }
.ui-jqgrid .ui-jqgrid-toppager .ui-pg-div  span.ui-icon {float:left;margin: 2px; width:18px;}
*/
/*subgrid*/
.ui-jqgrid .ui-jqgrid-btable .ui-sgcollapsed span {
  display: block;
}
.ui-jqgrid .ui-subgrid {
  margin: 0;
  padding: 0;
  width: 100%;
}
.ui-jqgrid .ui-subgrid table {
  table-layout: fixed;
}
.ui-jqgrid .ui-subgrid tr.ui-subtblcell td {
  height: 18px;
  border-right-width: 1px;
  border-right-color: inherit;
  border-right-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: inherit;
  border-bottom-style: solid;
}
.ui-jqgrid .ui-subgrid td.subgrid-data {
  border-top: 0 none !important;
  border-left: 0 none !important;
}
.ui-jqgrid .ui-subgrid td.subgrid-cell {
  border-width: 0 1px 1px 0;
}
.ui-jqgrid .ui-th-subgrid {
  height: 20px;
}
/* loading */
.ui-jqgrid .loading {
  position: absolute;
  top: 45%;
  left: 45%;
  width: auto;
  z-index: 101;
  padding: 6px;
  margin: 5px;
  text-align: center;
  font-weight: bold;
  display: none;
  border-width: 2px !important;
  font-size: 11px;
}
.ui-jqgrid .jqgrid-overlay {
  display: none;
  z-index: 100;
}
/* IE * html .jqgrid-overlay {width: expression(this.parentNode.offsetWidth+'px');height: expression(this.parentNode.offsetHeight+'px');} */
* .jqgrid-overlay iframe {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
/* IE width: expression(this.parentNode.offsetWidth+'px');height: expression(this.parentNode.offsetHeight+'px');}*/
/* end loading div */
/* toolbar */
.ui-jqgrid .ui-userdata {
  border-left: 0 none;
  border-right: 0 none;
  height: 27px;
  overflow: hidden;
}
/*Modal Window */
.ui-jqdialog {
  font-size: 11px !important;
}
.ui-jqdialog {
  display: none;
  width: 300px;
  position: absolute;
  padding: .2em;
  font-size: 11px;
  overflow: visible;
}
.ui-jqdialog .ui-jqdialog-titlebar {
  padding: .3em .2em;
  position: relative;
  height: 20px;
}
.ui-jqdialog .ui-jqdialog-title {
  margin: .3em .2em .2em .2em;
}
.ui-jqdialog .ui-jqdialog-titlebar-close {
  position: absolute;
  top: 50%;
  width: 19px;
  margin: -12px 0 0 0;
  padding: 1px;
  height: 18px;
  cursor: pointer;
}
.ui-jqdialog .ui-jqdialog-titlebar-close span {
  display: block;
  margin: 1px;
}
.ui-jqdialog-content,
.ui-jqdialog .ui-jqdialog-content {
  border: 0;
  padding: .3em .2em;
  background: none;
  height: auto;
}
.ui-jqdialog .ui-jqconfirm {
  padding: .4em 1em;
  border-width: 3px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  overflow: visible;
  display: none;
  height: 80px;
  width: 220px;
  text-align: center;
}
.ui-jqdialog > .ui-resizable-se {
  bottom: -3px;
  right: -3px;
}
.ui-jqgrid > .ui-resizable-se {
  bottom: -3px;
  right: -3px;
}
/* end Modal window*/
/* Form edit */
.ui-jqdialog-content .FormGrid {
  margin: 0;
  overflow: auto;
  position: relative;
}
.ui-jqdialog-content .EditTable {
  width: 100%;
  margin-bottom: 0;
}
.ui-jqdialog-content .DelTable {
  width: 100%;
  margin-bottom: 0;
}
.EditTable td input,
.EditTable td select,
.EditTable td textarea {
  margin: 0;
}
.EditTable td textarea {
  width: auto;
  height: auto;
}
.ui-jqdialog-content td.EditButton {
  text-align: right;
  border-top: 0 none;
  border-left: 0 none;
  border-right: 0 none;
  padding-bottom: 5px;
  padding-top: 5px;
}
.ui-jqdialog-content td.navButton {
  text-align: center;
  border-left: 0 none;
  border-top: 0 none;
  border-right: 0 none;
  padding-bottom: 5px;
  padding-top: 5px;
}
.ui-jqdialog-content input.FormElement {
  padding: .5em .3em;
  margin-bottom: 3px;
}
.ui-jqdialog-content select.FormElement {
  padding: .3em;
  margin-bottom: 3px;
}
.ui-jqdialog-content .data-line {
  padding-top: .1em;
  border: 0 none;
}
.ui-jqdialog-content .CaptionTD {
  vertical-align: middle;
  border: 0 none;
  padding: 2px;
  white-space: nowrap;
}
.ui-jqdialog-content .DataTD {
  padding: 2px;
  border: 0 none;
  vertical-align: top;
}
.ui-jqdialog-content .form-view-data {
  white-space: pre;
}
.fm-button {
  height: 18px;
  display: inline-block;
  margin: 2px 4px 0 0;
  padding: .6em .5em .2em .5em;
  text-decoration: none !important;
  cursor: pointer;
  position: relative;
  text-align: center;
  zoom: 1;
}
.fm-button-icon-left {
  padding-left: 1.9em;
}
.fm-button-icon-right {
  padding-right: 1.9em;
}
.fm-button-icon-left .ui-icon {
  right: auto;
  left: .2em;
  margin-left: 0;
  position: absolute;
  top: 50%;
  margin-top: -8px;
}
.fm-button-icon-right .ui-icon {
  left: auto;
  right: .2em;
  margin-left: 0;
  position: absolute;
  top: 50%;
  margin-top: -8px;
}
#nData,
#pData {
  float: left;
  margin: 3px;
  padding: 0;
  width: 15px;
}
.ViewTable {
  border-width: 0;
  border-style: none;
  border-spacing: 1px;
  padding: 4px;
  table-layout: fixed;
}
.ViewTable .CaptionTD,
.ViewTable .DataTD {
  padding: 4px;
}
/* End Eorm edit */
/*cell edit*/
.ui-jqgrid .edit-cell {
  padding: 4px 0px 4px 4px;
}
.ui-jqgrid .selected-row,
div.ui-jqgrid .selected-row td {
  font-style: normal;
  border-left: 0 none;
}
/* inline edit actions button*/
.ui-inline-del.ui-state-hover span,
.ui-inline-edit.ui-state-hover span,
.ui-inline-save.ui-state-hover span,
.ui-inline-cancel.ui-state-hover span {
  margin: -1px;
}
.ui-inline-del,
.ui-inline-cancel {
  margin-left: 8px;
}
.ui-jqgrid .inline-edit-cell {
  padding: 4px 0px 4px 4px;
}
/* Tree Grid */
.ui-jqgrid .tree-wrap {
  float: left;
  position: relative;
  height: 18px;
  white-space: nowrap;
  overflow: hidden;
}
.ui-jqgrid .tree-minus {
  position: absolute;
  height: 18px;
  width: 18px;
  overflow: hidden;
}
.ui-jqgrid .tree-plus {
  position: absolute;
  height: 18px;
  width: 18px;
  overflow: hidden;
}
.ui-jqgrid .tree-leaf {
  position: absolute;
  height: 18px;
  width: 18px;
  overflow: hidden;
}
.ui-jqgrid .treeclick {
  cursor: pointer;
}
/* moda dialog */
* iframe.jqm {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
/*	 width: expression(this.parentNode.offsetWidth+'px');height: expression(this.parentNode.offsetHeight+'px');}*/
.ui-jqgrid-dnd tr td {
  border-right-width: 1px;
  border-right-color: inherit;
  border-right-style: solid;
  height: 20px;
}
/* RTL Support */
.ui-jqgrid .ui-jqgrid-caption-rtl {
  text-align: right;
}
.ui-jqgrid .ui-jqgrid-hbox-rtl {
  float: right;
}
.ui-jqgrid .ui-jqgrid-resize-ltr {
  float: right;
  margin: -2px -2px -2px 0;
}
.ui-jqgrid .ui-jqgrid-resize-rtl {
  float: left;
  margin: -2px 0 -1px -3px;
}
.ui-jqgrid .ui-sort-rtl {
  left: 0;
}
.ui-jqgrid .tree-wrap-ltr {
  float: left;
}
.ui-jqgrid .tree-wrap-rtl {
  float: right;
}
.ui-jqgrid .ui-ellipsis {
  -moz-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
/* Toolbar Search Menu , Nav menu*/
.ui-search-menu,
.ui-nav-menu {
  position: absolute;
  padding: 2px 5px;
  z-index: 99999;
  -webkit-box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
  -moz-box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
  box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
}
.ui-search-menu.ui-menu .ui-menu-item,
.ui-nav-menu.ui-menu .ui-menu-item {
  list-style-image: none;
  padding-right: 0;
  padding-left: 0;
}
.ui-search-menu.ui-menu .ui-menu-item a,
.ui-nav-menu.ui-menu .ui-menu-item a {
  display: block;
}
.ui-search-menu.ui-menu .ui-menu-item a.g-menu-item:hover,
.ui-nav-menu.ui-menu .ui-menu-item a.g-menu-item:hover {
  margin: -1px;
  font-weight: normal;
}
.ui-jqgrid .ui-search-table {
  padding: 0;
  border: 0 none;
  height: 20px;
  width: 100%;
}
.ui-jqgrid .ui-search-table .ui-search-oper {
  width: 20px;
}
a.g-menu-item,
a.soptclass,
a.clearsearchclass {
  cursor: pointer;
}
.ui-jqgrid .ui-jqgrid-view input,
.ui-jqgrid .ui-jqgrid-view select,
.ui-jqgrid .ui-jqgrid-view textarea,
.ui-jqgrid .ui-jqgrid-view button {
  font-size: 11px;
}
.ui-jqgrid .ui-scroll-popup {
  width: 95px;
}
.ui-search-table select,
.ui-search-table input {
  padding: 4px 3px;
}
/* Column menu */
.ui-jqgrid .ui-jqgrid-htable .colmenu {
  position: absolute;
  right: 1px;
  height: 100%;
  color: black;
}
.ui-jqgrid .ui-jqgrid-htable .colmenu-rtl {
  right: auto;
  left: 1px;
}
.ui-jqgrid .ui-jqgrid-htable .colmenuspan {
  display: inline-block;
}
.ui-jqgrid .ui-jqgrid-htable .ui-th-div {
  height: 17px;
  margin-top: 5px;
  display: inine-block;
}
.column-menu,
.ui-search-menu {
  padding: 10px 10px;
}
.column-menu .divider {
  background-color: #e5e5e5;
  height: 1px;
  padding: 0 0;
  margin: 5px 0;
  overflow: hidden;
}
.ui-menu-item .ui-common-table .menu_icon {
  white-space: pre;
  padding-right: 4px;
  padding-left: 4px;
  width: auto;
}
.ui-menu-item .ui-common-table .menu_icon .ui-icon {
  display: inline-block;
  position: relative;
}
td.menu_text {
  width: auto;
  white-space: nowrap;
}
.ui-search-menu .ui-menu-item {
  padding: 0 0;
}
.ui-col-menu .ui-menu-item td.menu_text {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 1px;
}
.ui-col-menu .ui-menu-item td.menu_icon {
  padding-top: 0;
  padding-bottom: 0;
  vertical-align: middle;
}
.ui-col-menu .ui-menu-item td.menu_icon input {
  margin: 2px 0;
}
#search_menu .ui-menu-item div {
  margin: 3px 0;
  white-space: nowrap;
}
#search_menu .ui-menu-item div input,
#search_menu .ui-menu-item div select {
  padding: 3px 2px;
}
#search_menu .search_buttons {
  display: inline-block;
  width: 50%;
}
#column_menu.ui-menu .ui-menu-item {
  position: static;
}
/* 修改jqGrid样式和bang-UI统一样式风格 */
.jq-grid-container {
  /* 自定义类名样式 */
  /* 行编辑、添加、删除 */
}
.jq-grid-container .jqgroup b {
  font-weight: 700;
  color: #494949;
  font-size: 14px;
}
.jq-grid-container .jqgroup .ui-icon-circlesmall-minus {
  border-radius: 2px;
  display: inline-block;
  margin-top: 6px;
  width: 0;
  height: 0;
  border-left: 8px dashed transparent;
  border-right: 8px dashed transparent;
  border-top: 10px solid #494949;
}
.jq-grid-container .jqgroup .ui-icon-circlesmall-plus {
  border-radius: 2px;
  display: inline-block;
  margin-top: 2px;
  width: 0;
  height: 0;
  border-bottom: 8px dashed transparent;
  border-top: 8px dashed transparent;
  border-left: 10px solid #494949;
}
.jq-grid-container .ui-jqgrid-caption {
  min-height: 30px;
  padding: 4px 8px;
  border: 1px solid #E9E9E9;
  margin-bottom: -1px;
}
.jq-grid-container .ui-jqgrid-caption .HeaderButton {
  margin-right: 12px;
}
.jq-grid-container .ui-jqgrid-caption .ui-jqgrid-headlink {
  font-family: Arial;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  line-height: 18px;
  font-size: 18px;
  text-align: center;
  transition: all .3s;
  vertical-align: middle;
  border: 1px solid #999;
}
.jq-grid-container .ui-jqgrid-caption .ui-jqgrid-headlink.ui-icon-circle-triangle-n:after {
  content: '-';
}
.jq-grid-container .ui-jqgrid-caption .ui-jqgrid-headlink.ui-icon-circle-triangle-s:after {
  content: '+';
}
.jq-grid-container .ng-jq-grid-table tr {
  transition: all .3s;
  background-color: #FFF;
}
.jq-grid-container .ng-jq-grid-table tr:hover {
  background-color: #ECF6FD;
}
.jq-grid-container .ui-jqgrid table.ui-jqgrid-htable {
  empty-cells: hide;
}
.jq-grid-container .ui-jqgrid table.ui-jqgrid-htable .ui-jqgrid-sortable .s-ico .ui-grid-ico-sort {
  display: inline-block;
  margin-left: 4px;
  width: 0;
  height: 0;
  border-left: 6px dashed transparent;
  border-right: 6px dashed transparent;
  border-radius: 2px;
}
.jq-grid-container .ui-jqgrid table.ui-jqgrid-htable .ui-jqgrid-sortable .s-ico .ui-grid-ico-sort.ui-icon-asc {
  border-bottom: 6px solid #333;
  margin-top: 3px;
}
.jq-grid-container .ui-jqgrid table.ui-jqgrid-htable .ui-jqgrid-sortable .s-ico .ui-grid-ico-sort.ui-icon-asc.ui-state-disabled {
  border-bottom-color: #999;
}
.jq-grid-container .ui-jqgrid table.ui-jqgrid-htable .ui-jqgrid-sortable .s-ico .ui-grid-ico-sort.ui-icon-desc {
  border-top: 6px solid #333;
  margin-top: 11px;
}
.jq-grid-container .ui-jqgrid table.ui-jqgrid-htable .ui-jqgrid-sortable .s-ico .ui-grid-ico-sort.ui-icon-desc.ui-state-disabled {
  border-top-color: #999;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view tr.ui-state-highlight {
  background-color: #DFF0D8;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view th {
  border-right: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9 !important;
  border-top: 1px solid #E9E9E9 !important;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view th:first-of-type {
  border-left: 1px solid #E9E9E9;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view td {
  border-right: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view td:first-of-type {
  border-left: 1px solid #E9E9E9;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view td {
  padding: 10px 8px;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view td:empty {
  padding: 0;
  border: 0 none;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-view th {
  background-color: #F5F5F5;
  color: #494949;
  padding: 6px 0;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager .ui-pager-control {
  height: 26px;
  padding: 2px 8px 10px;
  box-sizing: content-box;
  color: #494949;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr {
  height: 30px;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-icon {
  font-family: Arial;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  min-width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  transition: all .3s;
  vertical-align: middle;
  border: 1px solid #999;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr input.ui-pg-input,
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr select.ui-pg-selbox {
  height: 22px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  margin: 0 4px;
  border-radius: 4px;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr input.ui-pg-input:focus,
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr select.ui-pg-selbox:focus {
  outline: none !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(16, 142, 233, 0.6);
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-separator {
  border: 0 none;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-icon:hover {
  border-color: #108ee9;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-icon-seek-first:after {
  content: "|<";
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-icon-seek-prev:after {
  content: "<";
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-icon-seek-next:after {
  content: ">";
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-icon-seek-end:after {
  content: ">|";
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-corner-all.ui-state-disabled {
  cursor: not-allowed !important;
}
.jq-grid-container .ui-jqgrid .ui-jqgrid-pager tr .ui-corner-all.ui-state-disabled .ui-icon {
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.15);
}
.jq-grid-container .ui-jqgrid .ui-search-toolbar th {
  padding: 0;
}
.jq-grid-container .ui-jqgrid .ui-search-toolbar .ui-search-input input {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.jq-grid-container .ui-jqgrid .ui-search-toolbar .ui-search-input input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.jq-grid-container .ui-pg-table.ui-common-table .ui-state-disabled:empty {
  display: none;
}
.jq-grid-container .ui-pg-table.ui-common-table span.ui-icon-document:after {
  content: '查看';
}
.jq-grid-container .ui-pg-table.ui-common-table span.ui-icon-search:after {
  content: '查找';
}
.jq-grid-container .ui-pg-table.ui-common-table span.ui-icon-refresh:after {
  content: '刷新';
}
.jq-grid-container .ui-pg-table.ui-common-table span.ui-icon-pencil:after {
  content: '编辑';
}
.jq-grid-container .ui-pg-table.ui-common-table span.ui-icon-plus:after {
  content: '添加';
}
.jq-grid-container .ui-pg-table.ui-common-table span.ui-icon-trash:after {
  content: '删除';
}
.jq-grid-container .frozen-bdiv {
  margin-top: -1px;
}
.jq-grid-container tr.ng-jq-grid-even {
  background-color: #F9F9F9;
}
.jq-grid-container .ng-jq-grid-btn {
  display: inline-block;
  margin-right: 4px;
  font-weight: 500;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  white-space: nowrap;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
}
.jq-grid-container .ng-jq-grid-btn:hover {
  color: #108ee9;
  border-color: #108ee9;
}
.jq-grid-container .ng-jq-grid-btn:focus {
  outline: 0;
}
.jq-grid-container .jqgrow .ui-pg-div {
  cursor: pointer;
  font-family: Arial;
  color: rgba(0, 0, 0, 0.65);
  min-width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  transition: all .3s;
  vertical-align: middle;
}
.jq-grid-container .jqgrow .ui-pg-div.ui-inline-edit:after {
  content: '编辑';
  transform: scale(0.8);
}
.jq-grid-container .jqgrow .ui-pg-div.ui-inline-del:after {
  content: '删除';
}
.jq-grid-container .jqgrow .ui-pg-div.ui-inline-save:after {
  content: '保存';
}
.jq-grid-container .jqgrow .ui-pg-div.ui-inline-cancel:after {
  content: '取消';
}
.jq-grid-container .jqgrow input.inline-edit-cell.ui-corner-all {
  display: block;
  width: 94%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.jq-grid-container .jqgrow input.inline-edit-cell.ui-corner-all:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
/* 工具栏相关 */
.ui-jqdialog {
  height: auto !important;
  background-color: #fff;
  padding: 0 0 10px;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
}
.ui-jqdialog .ui-jqdialog-titlebar {
  border-bottom: 1px solid #E5E5E5;
  min-height: 35px;
}
.ui-jqdialog .ui-jqdialog-title {
  margin: .4em .2em .2em .5em;
}
.ui-jqdialog .ui-jqdialog-titlebar-close {
  margin-right: 6px;
}
.ui-jqdialog .ui-icon-closethick {
  display: inline-block;
  font-family: Arial;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 9px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  transition: all .3s;
  vertical-align: middle;
  border: 1px solid #999;
}
.ui-jqdialog .ui-icon-closethick span {
  display: inline-block;
}
.ui-jqdialog .ui-icon-closethick:hover {
  border-color: #108ee9;
}
.ui-jqdialog .ui-icon-closethick:after {
  content: "X";
}
.ui-jqdialog .navButton #nData,
.ui-jqdialog .navButton #pData {
  margin: 3px 12px;
}
.ui-jqdialog .navButton .ui-icon {
  display: inline-block;
  font-family: Arial;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  min-width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  transition: all .3s;
  vertical-align: middle;
  border: 1px solid #999;
}
.ui-jqdialog .navButton .ui-icon:hover {
  border-color: #108ee9;
}
.ui-jqdialog .navButton .ui-icon-triangle-1-w:after {
  content: '<';
}
.ui-jqdialog .navButton .ui-icon-triangle-1-e:after {
  content: '>';
}
.ui-jqdialog .CaptionTD label {
  font-weight: 700;
  padding-left: 8px;
}
.ui-jqdialog input.FormElement.ui-corner-all {
  margin-top: -10px;
  margin-left: -14px;
  display: block;
  width: 94%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.ui-jqdialog input.FormElement.ui-corner-all:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.ui-jqdialog hr {
  border: 0 none;
  border-top: 1px solid #E5E5E5;
}
.ui-jqdialog .ui-search-table select.ui-widget-content,
.ui-jqdialog .ui-search-table input.input-elm {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.ui-jqdialog .ui-search-table select.ui-widget-content:focus,
.ui-jqdialog .ui-search-table input.input-elm:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.ui-jqdialog .confirm.ui-jqconfirm {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
`],
  encapsulation: ViewEncapsulation.None,
  providers : [JqGridService]
})

export class JqGridComponent implements AfterViewInit, OnDestroy, DoCheck {
  private interfaceOptions: JqGridInterFaceOptions;
  private functionOptions: JqGridFunctionOptions;
  private eventOptions: Object;
  private inputData: Array<any>;
  dataDiffer: KeyValueDiffer<{}, {}>;

  // 表格数据
  @Input()
  public set data(value: any) {
    this.inputData = value;
    this.gird.updateData(value);
  }

  public get data(): any {
    return this.inputData;
  }
  /* 界面参数 */
  @Input() colModel: Array<Object>;
  @Input() viewrecords?: boolean;
  @Input() rownumbers?: boolean;
  @Input() rownumWidth?: number;
  @Input() altRows?: boolean;
  @Input() caption?: string;
  @Input() hidegrid?: boolean;
  @Input() hiddengrid?: boolean;
  @Input() rowNum?: number;
  @Input() rowList?: Array<number>;
  @Input() sortname?: string;
  @Input() sortorder?: string;
  @Input() multiSort?: boolean;
  @Input() forceFit?: boolean;
  @Input() grouping?: boolean;
  @Input() groupingView?: Object;
  @Input() shrinkToFit?: boolean;
  @Input() autowidth?: boolean;
  @Input() width?: number;
  @Input() colNames?: Array<any>;
  @Input() deselectAfterSort?: boolean;
  @Input() height?: any;
  @Input() page?: number;
  @Input() pgbuttons?: boolean;
  @Input() pginput?: boolean;
  @Input() hidePagerBar?: boolean;
  @Input() url?: string;
  @Input() mtype?: string;
  @Input() datatype?: string;
  @Input() jsonReader?: Object;
  @Input() editurl?: string;
  @Input() loadonce?: boolean;


  /* 功能参数 */
  @Input() groupHeaders?: Array<Object>;
  @Input() showFiltertoolBar?: boolean;
  @Input() toolBarSettings?: Object;
  @Input() flozenColums?: boolean;


  /* 导出组件事件 */
  @Output() rightClickRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() dblClickRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickCell: EventEmitter<any> = new EventEmitter<any>();
  @Output() paging: EventEmitter<any> = new EventEmitter<any>();
  @Output() beforeSelectRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterInsertRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() beforeRequest: EventEmitter<any> = new EventEmitter<any>();
  @Output() gridComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadError: EventEmitter<any> = new EventEmitter<any>();


  @ViewChild('jqGridTable')
  jqGridTable: ElementRef;

  @ViewChild('jqGridPager')
  jqGridPager: ElementRef;

  constructor(public gird: JqGridService, private elementRef: ElementRef, private differs: KeyValueDiffers ) {
    this.dataDiffer = differs.find({}).create();
  }

  ngAfterViewInit(): void {
    this.jqGridTable.nativeElement.id = 'jqGrid' + Date.now();
    this.interfaceOptions = {
      colModel: this.colModel || undefined,
      viewrecords: this.viewrecords || false,
      rownumbers: this.rownumbers || false,
      rownumWidth: this.rownumWidth || 25,
      altRows: this.altRows || false,
      caption: this.caption || undefined,
      hidegrid: this.hidegrid === undefined ? true : this.hidegrid,
      hiddengrid: this.hiddengrid || false,
      rowNum: this.rowNum || 10,
      rowList: this.rowList || undefined,
      sortname: this.sortname || undefined,
      sortorder: this.sortorder || 'asc',
      multiSort: this.multiSort || false,
      forceFit: this.forceFit || false,
      grouping: this.grouping || false,
      groupingView: this.groupingView || undefined,
      shrinkToFit: this.shrinkToFit === undefined ? true : this.shrinkToFit,
      autowidth: this.autowidth === undefined ? true : this.autowidth,
      width: this.width || undefined,
      colNames: this.colNames || undefined,
      deselectAfterSort: this.deselectAfterSort === undefined ? true : this.deselectAfterSort,
      height: this.height || 'auto',
      page: this.page || 1,
      pgbuttons: this.pgbuttons === undefined ? true : this.pgbuttons,
      pginput: this.pginput === undefined ? true : this.pginput,
      hidePagerBar: this.hidePagerBar || false,
      url: this.url || undefined,
      mtype: this.mtype || 'GET',
      datatype: this.datatype || 'local',
      jsonReader: this.jsonReader || {root: 'rows', page: 'page', total: 'total', records: 'records', repeatitems: false},
      editurl: this.editurl || undefined,
      loadonce: this.loadonce || false,
    }
    this.functionOptions = {
      groupHeaders: this.groupHeaders || undefined,
      showFiltertoolBar: this.showFiltertoolBar || false,
      toolBarSettings: this.toolBarSettings || undefined,
      flozenColums: this.flozenColums || false,
    }
    this.eventOptions = {
      onRightClickRow: (rowid: any, iRow: any, iCol: any, event: any) => { this.rightClickRow.emit({rowid, iRow, iCol, event})},
      ondblClickRow: (rowid: any, iRow: any, iCol: any, event: any) => { this.dblClickRow.emit({rowid, iRow, iCol, event})},
      onCellSelect: (rowid: any, iCol: any, cellcontent: any, event: any) => { this.clickCell.emit({rowid, iCol, cellcontent,  event})},
      onPaging: (pgButton: any) => { this.paging.emit({pgButton})},
      beforeSelectRow: (rowid: any, event: any) => { this.beforeSelectRow.emit({rowid, event})},
      afterInsertRow: (rowid: any, rowdata: any) => { this.afterInsertRow.emit({rowid, rowdata})},
      beforeRequest: () => { this.beforeRequest.emit()},
      gridComplete: () => { this.gridComplete.emit()},
      loadComplete: (xhr: any) => { this.loadComplete.emit({xhr})},
      loadError: (xhr: any, status: any, error: any) => { this.loadError.emit({xhr, status, error})},
    }
    this.gird.init(this.jqGridTable.nativeElement, this.jqGridPager.nativeElement, this.data, this.interfaceOptions, this.eventOptions, this.functionOptions);
  }

  ngDoCheck(): void {
    if (this.dataDiffer.diff(this.data)) {
      this.gird.updateData(this.data);
    }
  }

  ngOnDestroy(): void {
    this.gird.destroy();
  }

}
